import React from "react";
import { useNavigate } from "react-router-dom";
import { Youtube, Music2, Instagram, Calendar } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { sectionLabel, localize } from "@/lib/constants";

export const ContentCard = ({ item, lang }) => {
  const navigate = useNavigate();
  const cover = mediaUrl(item.cover_image_url);
  const s = item.social_links || {};
  const title = localize(item.title, lang);
  const meta = localize(item.meta_description, lang);
  const dateStr = item.published_at || item.created_at;

  return (
    <article
      data-testid={`content-card-${item.id}`}
      onClick={() => navigate(`/content/${item.id}`)}
      className="group cursor-pointer rounded-2xl overflow-hidden border border-[#2D3748] bg-[#121620] hover:border-[#8B5CF6]/50 hover:-translate-y-1 transition-all duration-300 flex flex-col"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[#1A202C]">
        {cover ? (
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-violet-900/40 to-cyan-900/30">
            <Music2 className="w-10 h-10 text-[#8B5CF6]/60" />
          </div>
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="px-2.5 py-1 rounded-full text-[11px] font-semibold bg-[#0B0D12]/80 backdrop-blur text-[#8B5CF6] border border-[#8B5CF6]/30">
            {sectionLabel(item.category, lang)}
          </span>
        </div>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-heading text-lg font-semibold text-white leading-snug line-clamp-2 group-hover:text-[#a78bfa] transition-colors">
          {title}
        </h3>
        {meta && (
          <p className="text-sm text-[#94A3B8] mt-2 line-clamp-2">{meta}</p>
        )}
        <div className="mt-auto pt-4 flex items-center justify-between">
          <span className="flex items-center gap-1.5 text-xs text-[#64748B]">
            <Calendar className="w-3.5 h-3.5" />
            {dateStr && new Date(dateStr).toLocaleDateString(lang === "IT" ? "it-IT" : "en-US", {
              day: "numeric", month: "short", year: "numeric",
            })}
          </span>
          <div className="flex items-center gap-2 text-[#64748B]">
            {s.youtube && <Youtube className="w-4 h-4 text-red-400" />}
            {s.tiktok && <Music2 className="w-4 h-4 text-[#06B6D4]" />}
            {s.instagram && <Instagram className="w-4 h-4 text-pink-400" />}
          </div>
        </div>
      </div>
    </article>
  );
};
